<h2>Test Kits</h2>

<mat-spinner *ngIf="initializing"></mat-spinner>

<div class="button_row" *ngIf="!initializing">
    <button mat-raised-button
            routerLink="/">Back</button>
</div>

<div *ngIf="kits?.length && !initializing" class="paginator_row">
    <mat-paginator #paginator
                   [hidden]="initializing"
                   [length]="total"
                   [pageIndex]="INITIAL_PAGE_INDEX"
                   [pageSize]="INITIAL_PAGE_SIZE"
                   [pageSizeOptions]="[5, 10, 20]"
                   (page)="pageChanged($event)"></mat-paginator>
</div>
<table mat-table *ngIf="kits?.length && !initializing"
       [dataSource]="kitRange">

    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let kit" [innerHTML]="kit.email"></td>
    </ng-container>

    <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Code</th>
        <td mat-cell *matCellDef="let kit">{{formatCode(kit.code)}}</td>
    </ng-container>

    <ng-container matColumnDef="updated">
        <th mat-header-cell *matHeaderCellDef>Updated</th>
        <td mat-cell *matCellDef="let kit">{{formatUpdatedAsLocal(kit)}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let kit">{{kit.status}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let kit">
            <mat-icon class="link" (click)="editStatus(kit)">edit</mat-icon>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row
        *matRowDef="let kit; columns: columnsToDisplay"></tr>

</table>

